import { InfoCircleFilled } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Button, Popover } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { StyledRichTextAdvancedText } from '../../inputs/rich-text/style/StyledRichTextAdvancedText';

const StyledInfoButton = styled(Button)`
  &&& {
    padding: 0;
    padding-left: 4px;
    margin: 0;
    width: auto;
    height: auto;
    border: none;
    background: none;

    .anticon {
      font-size: 16px;
      margin-right: 0;
      .ant-form-item-label & {
        font-size: 12px;
      }
      .ant-form-item-explain & {
        font-size: 14px;
      }
    }
    // correggiamo il colore per l'accessibilità quando è in una header di tabella
    .ant-table-thead & {
      color: #fff;
      opacity: 1;
      &:hover {
        opacity: 0.85;
      }
    }
  }
`;

export interface IInfoIconProps {
  text?: React.ReactNode | string | null;
}

/**
 * Icona informativa con popover
 */
export function InfoIcon(props: IInfoIconProps) {
  const { text } = props;
  const [visible, setVisible] = React.useState(false);
  const { t } = useTranslation();
  if (!text) return null;

  return (
    <Popover
      overlayStyle={{ maxWidth: '90%', width: '424px' }}
      content={
        <StyledRichTextAdvancedText hasCustomFont>
          {text}
        </StyledRichTextAdvancedText>
      }
      trigger="click"
      onOpenChange={e => {
        setVisible(e);
      }}
    >
      <StyledInfoButton
        type="link"
        title={t('ui.info-icon.content', 'Testo informativo aggiuntivo')}
        icon={<InfoCircleFilled aria-hidden />}
        aria-expanded={visible}
      />
    </Popover>
  );
}
